import { useEffect } from 'react'

import {
  ArtworkDownloadProvider,
  ArtworkBuilderProvider,
  setAccessToken as setArtworkBuilderAccessToken,
} from '@domain-group/artwork-builder'

import { useNumericParams } from '@domain-group/react-hooks'

import { MainContent, TopBar } from '@domain-group/suit-theme'

import { getAccessToken } from '@functions/accessToken'

import useCampaign from '@hooks/useCampaign'
import useCampaignQuotes from '@hooks/useCampaignQuotes'
import useCampaignSync from '@hooks/useCampaignSync'
import useCurrentUser from '@hooks/useCurrentUser'
import useLoadEntity from '@hooks/useLoadEntity'
import useMainNavigation from '@hooks/useMainNavigation'
import useProviders from '@hooks/useProviders'

import DashboardSearch from '@components/DashboardSearch'
import LoggedInUser from '@components/LoggedInUser'
import MainNavigation from '@sections/Client/components/MainNavigation'
import Notifications from '@components/Notifications'

import defaultRequestOptions from './defaultRequestOptions'

import CampaignRoutes from './routes'

import Navigation from './components/Navigation'

const Campaign = () => {
  const { callbacks: { toggleNavigation } } = useMainNavigation()

  const { campaignId } = useNumericParams()

  const currentUserPayload = useCurrentUser()

  const campaignPayload = useCampaign({ id: campaignId }, {
    performHttpRequests: !!campaignId,
    requestOptions: defaultRequestOptions.campaign,
    skipLoadedForKeysCheck: true,
  })
  const { agency, campaign } = campaignPayload

  useCampaignQuotes({
    filters: {
      campaign_id: campaign.id,
    },
    performHttpRequests: !!campaign.id,
    requestOptions: defaultRequestOptions.campaignQuote,
  })

  useProviders({
    performHttpRequests: true,
    requestOptions: defaultRequestOptions.provider,
  })

  useCampaignSync()

  // Set accessToken for ArtworkBuilder
  useEffect(() => {
    setArtworkBuilderAccessToken(getAccessToken() || '')
  }, [])

  // redirects to root if campaign doesn't load
  useLoadEntity({ entityId: campaign.id, entityType: 'campaign' })

  return (
    <ArtworkBuilderProvider>
      <ArtworkDownloadProvider configOptions={{ ablyPublicKey: process.env.REACT_APP_ABLY_ARTWORK_BUILDER_PUBLIC_KEY || '' }}>
        <TopBar
          callbacks={{ toggleNavigation }}
          loggedInUserComponent={<LoggedInUser />}
          nestedNavigation
          notificationsComponent={<Notifications />}
          searchComponent={<DashboardSearch />}
        />

        <MainNavigation
          minimized
          nestedNavigation={(
            <Navigation
              agency={agency}
              campaign={campaign}
              currentUserPayload={currentUserPayload}
            />
          )}
        />

        <MainContent nestedNavigation offset={{ top: TopBar.topBarHeight }}>
          {/*
           // @ts-expect-error TS2740 */}
          <CampaignRoutes agency={agency} campaign={campaign} />
        </MainContent>
      </ArtworkDownloadProvider>
    </ArtworkBuilderProvider>
  )
}

export default Campaign
